// extracted by mini-css-extract-plugin
module.exports = {"app":"App-module--app--1ISYJ","main":"App-module--main--1Tcdm"};